"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryCanvas = void 0;
var fabric_1 = require("fabric");
var Properties_1 = require("./Properties");
var FacetRenderer_1 = require("../renderers/FacetRenderer");
var luxon_1 = require("luxon");
var HistoryCanvas = /** @class */ (function (_super) {
    __extends(HistoryCanvas, _super);
    function HistoryCanvas() {
        var _this = _super.call(this, 'canvas') || this;
        fabric_1.fabric.Object.prototype.selectable = false;
        fabric_1.fabric.Textbox.prototype.editable = false;
        fabric_1.fabric.Textbox.prototype.fontFamily = 'sans';
        _this.initializeCanvas();
        return _this;
    }
    HistoryCanvas.prototype.initializeCanvas = function () {
        this.setDimensions({ width: window.innerWidth, height: window.innerHeight });
        this.hoverCursor = 'default';
        this.selection = false;
        this.absolutePan(new fabric_1.fabric.Point(HistoryCanvas.calculateAbsoluteX(luxon_1.DateTime.fromISO('1500-01-01')), 0));
        this.renderOnAddRemove = false;
        this.ticks = [];
    };
    HistoryCanvas.prototype.getItem = function (id) {
        for (var i = 0, len = _super.prototype.size.call(this); i < len; i++) {
            if (this.getObjects()[i].id && this.getObjects()[i].id === id) {
                return this.getObjects()[i];
            }
        }
    };
    HistoryCanvas.prototype.render = function (facets) {
        this.renderGrid();
        this.renderData(facets.sort(function (one, two) { return one.orderByStart(two); }));
        this.requestRenderAll();
    };
    HistoryCanvas.prototype.renderGrid = function () {
        this.remove.apply(this, this.ticks);
        this.ticks.length = 0;
        for (var currentTick = Properties_1.FIRST_TICK; currentTick < Properties_1.LAST_TICK; currentTick = currentTick.plus(this.periodBetweenTicks())) {
            var x = HistoryCanvas.calculateAbsoluteX(currentTick);
            var line = new fabric_1.fabric.Line([
                x,
                -this.viewportTransform[5] / this.viewportTransform[3],
                x,
                (-this.viewportTransform[5] + window.innerHeight) / this.viewportTransform[3]
            ], {
                stroke: Properties_1.GRID_COLOR.hex(),
                strokeWidth: 1
            });
            var label = new fabric_1.fabric.Textbox(currentTick.year.toString(), {
                left: x,
                top: (-this.viewportTransform[5] + window.innerHeight - Properties_1.LANE_HEIGHT) / this.viewportTransform[3],
                originX: 'center',
                originY: 'center',
                fontSize: (Properties_1.LANE_HEIGHT - 4) / this.viewportTransform[3],
                textAlign: 'center',
                strokeWidth: 0,
                fill: Properties_1.GRID_COLOR.hex(),
                textBackgroundColor: Properties_1.BACKGROUND_COLOR.hex()
            });
            var gridline = new fabric_1.fabric.Group([line, label]);
            this.insertAt(gridline, 1, false);
            this.ticks.push(gridline);
        }
    };
    HistoryCanvas.prototype.periodBetweenTicks = function () {
        return luxon_1.Duration.fromObject({ years: 25 / this.getZoom() });
    };
    HistoryCanvas.prototype.tickCount = function () {
        return this.ticks.length - 1;
    };
    HistoryCanvas.prototype.renderData = function (facets) {
        var _this = this;
        facets.reduce(function (offset, facet) { return new FacetRenderer_1.FacetRenderer(_this, facet).render(offset); }, 0);
        this.renderAll();
    };
    HistoryCanvas.calculateAbsoluteX = function (date) {
        return HistoryCanvas.calculateRelativeX(Properties_1.DATE_ORIGIN, date);
    };
    HistoryCanvas.calculateRelativeX = function (start, end) {
        return end.diff(start, Properties_1.DATE_SCALE_UNIT).as(Properties_1.DATE_SCALE_UNIT) / Properties_1.DATE_SCALE_FACTOR;
    };
    return HistoryCanvas;
}(fabric_1.fabric.Canvas));
exports.HistoryCanvas = HistoryCanvas;
